export const getSvgDataUri = (svg: string): string =>
  `url('data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
    svg
      .trim()
      .replace(/[\n\r]+/g, '')
      .replace(/\s+/g, ' '),
  )}')`;
